import EntryProduct from './EntryProduct';

export default EntryProduct;
